import { axiosAssessmentInstance } from "../AxiosConfiguration";
import Cookies from "js-cookie";

export const getNotificationWebhook = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      `/api/notification/get`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        params: {
          webhook: true,
        },
      }
    );
    return response?.data?.payload;
  } catch (error) {
    console.error("Error during webhook API call:", error);
    return error;
  }
};

export const getNotification = async ({ page = 1 }) => {
  if (Cookies.get("idtoken")) {
    try {
      const response = await axiosAssessmentInstance.get(
        `/api/v2/notification/in-app`,
        {
          params: {
            page,
          },
        }
      );
      return response?.data?.payload;
    } catch (error) {
      console.error("Error during API call:", error);
      throw error;
    }
  }
};

// New unread count endpoint for dashboard bell icon
export const getUnreadNotificationCount = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      `/api/v2/notification/dashboard/unread-count`
    );
    // Expected shape:
    // { status, status_code, message, payload: { count: number } }
    const count = response?.data?.payload?.count;
    return typeof count === "number" ? count : 0;
  } catch (error) {
    console.error("Error fetching unread notification count:", error);
    return 0;
  }
};

///api/notification/mark/read
export const markAsReadNotification = async (id) => {
  try {
    const response = await axiosAssessmentInstance.post(
      `/api/notification/mark/read`,
      { notification_id: id }
    );
    return response?.data?.payload;
  } catch (error) {
    console.error("Error during API call:", error);
    return error;
  }
};

// V2 mark read endpoint; supports mark_all
export const markReadV2 = async ({ notification_id = undefined, mark_all = false } = {}) => {
  try {
    const response = await axiosAssessmentInstance.post(
      `/api/v2/notification/mark/read`,
      {
        ...(notification_id ? { notification_id } : {}),
        mark_all,
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during v2 mark read API call:", error);
    throw error;
  }
};
